import axios from '../../axios'

/*
 * 黑白名单（userPerm） - 数据接口
 */

// 获取黑白名单
export const getUserPerm = (data) => {
    return axios({
        url: '/api/admin/wish/user/perm/info',
        method: 'get',
        data
    })
}

// 获取黑白名单
export const getUserPermList = (data) => {
    return axios({
        url: '/api/admin/wish/user/perm',
        method: 'get',
        data
    })
}

// 新增黑白名单信息
export const saveUserPerm = (data) => {
    return axios({
        url: '/api/admin/wish/user/perm',
        method: 'post',
        data
    })
}

// 编辑黑白名单信息
export const updateUserPerm = (data) => {
    return axios({
        url: '/api/admin/wish/user/perm',
        method: 'put',
        data
    })
}

// 服务卡管理后台接口
export const userPerm = (data) => {
    return axios({
        url: '/api/admin/wish/user/perm',
        method: data.method,
        data: data.data
    })
}

// 删除黑白名单
export const deleteUserPerm = (data) => {
    return axios({
        url: '/api/admin/wish/user/perm',
        method: 'delete',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/userperm.js